import { Component, Input } from "@angular/core";

@Component({
  selector: "li-eye",
  templateUrl: "./eye.component.html",
})
export class EyeComponent {
  @Input() height = 16;
  @Input() width = 16;
}